import {ref} from 'vue';

export function useAlerts() {
    const alerts = ref([]);

    function flash(message, level = 'success', autohide = 5000) {
        alerts.value.push({message, level});

        if (autohide) {
            setTimeout(() => alerts.value.pop(), autohide);
        }
    }

    function clear() {
        alerts.value = [];
    }

    return {
        alerts,
        flash,
        clear,
    };
}
